export default __webpack_public_path__ + "static/media/short stay Transit Visa (Seamen).a02038b0.jpg";